import { NgModule } from '@angular/core'
import { ConfigModule, RoutingModule, UrlModule } from '@spartacus/core'
import { MbCategoryNavigationComponent } from './mb-category-navigation.component'
import { NavigationNode } from '../mb-navigation.service'
import { RouterModule } from '@angular/router'
import { LazyLoadImageModule } from 'ng-lazyload-image'
import { CmsComponentsBaseModule } from '../../components/cms-components-base.module'
import { LinkModule } from '../../components/shared/link/link.module'
import { SafeHtmlModule } from '../../pipes/sanitize-html/safe-html.module'
import { MbSearchBoxModule } from '../../../shared/components/mb-search-box/mb-search-box.module'
import { ContactBoxNavigationModule } from '../../components/contact-box/contact-box-navigation/contact-box-navigation.module'
import { MbI18nModule } from '../../../translations/mb-i18n.module'
import { MbCategoryNavigationLinkModule } from './mb-category-navigation-link/mb-category-navigation-link.module'
import { MbCategoryNavigationLinkComponent } from './mb-category-navigation-link/mb-category-navigation-link.component'
import { PictureModule } from '../../components/shared/picture/picture.module'
import { MbCategoryNavigationLogoComponent } from './mb-category-navigation-logo/mb-category-navigation-logo.component'
import { MbCategoryNavigationCategoriesComponent } from './mb-category-navigation-categories/mb-category-navigation-categories.component'
import { MbCategoryNavigationThirdLevelComponent } from './mb-category-navigation-third-level/mb-category-navigation-third-level.component'
import {
  MbCategoryNavigationFourthLevelComponent
} from './mb-category-navigation-fourth-level/mb-category-navigation-fourth-level.component'
import { MbCategoryNavigationFirstLevelComponent } from './mb-category-navigation-first-level/mb-category-navigation-first-level.component'
import {
  MbCategoryNavigationSecondLevelComponent
} from './mb-category-navigation-second-level/mb-category-navigation-second-level.component'
import {
  MbCategoryNavigationToolsMobileComponent
} from './mb-category-navigation-tools/mb-category-navigation-tools-mobile/mb-category-navigation-tools-mobile.component'
import {
  MbCategoryNavigationToolsDesktopComponent
} from './mb-category-navigation-tools/mb-category-navigation-tools-desktop/mb-category-navigation-tools-desktop.component'

@NgModule({
  declarations: [
    MbCategoryNavigationComponent,
    MbCategoryNavigationLinkComponent,
    MbCategoryNavigationLogoComponent,
    MbCategoryNavigationCategoriesComponent,
    MbCategoryNavigationFirstLevelComponent,
    MbCategoryNavigationSecondLevelComponent,
    MbCategoryNavigationThirdLevelComponent,
    MbCategoryNavigationFourthLevelComponent,
    MbCategoryNavigationToolsMobileComponent,
    MbCategoryNavigationToolsDesktopComponent
  ],
  imports: [
    CmsComponentsBaseModule,
    RouterModule,
    LazyLoadImageModule,
    UrlModule,
    MbSearchBoxModule,
    ContactBoxNavigationModule,
    LinkModule,
    SafeHtmlModule,
    MbI18nModule,
    MbCategoryNavigationLinkModule,
    PictureModule,
    RoutingModule,
    ConfigModule.withConfig({
      cmsComponents: {
        CategoryNavigationComponent: {
          component: MbCategoryNavigationComponent
        },
      }
    }),
  ],
  exports: [
    MbCategoryNavigationComponent,
    MbCategoryNavigationLinkComponent
  ]
})
export class MbCategoryNavigationModule {
}

export type SelectedSubCategories = SelectedNavigationElement

export type SelectedFilter = SelectedNavigationElement

export interface SelectedNavigationElement {
  [category: string]: NavigationNode | null;
}
